"use client";

import {
  Checkbox,
  TypographyCaption,
  TypographyText,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import type { SelectedProvider } from "../../../types";

type Props = {
  provider: SelectedProvider;
  count: number;
  isSelected: boolean;
  onToggle: (provider: SelectedProvider) => void;
};

const ProviderDropdownItem: FC<Props> = ({
  provider,
  count,
  isSelected,
  onToggle,
}) => {
  const handleToggle = () => {
    onToggle(provider);
  };

  return (
    <label className="flex w-full p-2 gap-3 hover:bg-secondary/40 select-none rounded-lg hover:cursor-pointer justify-center items-center">
      <Checkbox
        checked={isSelected}
        onCheckedChange={handleToggle}
        className="m-0!"
      />
      <TypographyText className="m-0! font-medium" variant="small">
        {provider.name}
      </TypographyText>
      <div className="flex-1" />
      <TypographyCaption>{count}</TypographyCaption>
    </label>
  );
};

export default ProviderDropdownItem;
